<!--  -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-right search-sh">
                <div class="search-name">编码</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.APCode" v-filter-special-char="searchData.APCode" placeholder="请输入汽配编码"></el-input>
                <div class="search-name">名称</div>
                <el-select
                    size="small"
                    class="search-item"
                    v-model="searchData.GoodName"
                    remote
                    filterable
                    allow-create
                    clearable
                    placeholder="请输入配件名称"
                    :remote-method="searchGoodName"
                    v-select-scroll-more="searchGoodNameLoad"
                    popper-class="my-select"
                >
                    <el-option v-for="item in goodNameOptions" :key="item" :label="item" :value="item"> </el-option>
                    <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                        加载中
                        <i class="el-icon-loading"></i>
                    </el-option>
                </el-select>
                <div class="search-name">分类</div>
                <el-select
                    class="search-item"
                    v-model="searchData.Cate"
                    collapse-tags
                    filterable
                    clearable
                    size="small"
                    @visible-change="getGoodsType($event)"
                    placeholder="请输入汽配分类"
                >
                    <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                        <div class="option-content">
                            <div>{{ optionItem.Text }}</div>
                        </div>
                    </el-option>
                    <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                </el-select>
                <div class="search-name">客户</div>
                <el-select
                    class="search-item"
                    v-model="cust"
                    filterable
                    clearable
                    allow-create
                    remote
                    reserve-keyword
                    value-key="EntpCusId"
                    size="small"
                    :remote-method="searchCustomer"
                    v-select-scroll-more="searchCustomLoad"
                    @visible-change="customerVisibleChange($event)"
                    @change="custChange($event)"
                    placeholder="输入客户名称/电话"
                >
                    <el-option v-for="optionItem in customerList" :key="optionItem.EntpCusId" :data-msg="optionItem" :label="optionItem.EntpCusName" :value="optionItem"
                        ><span style="float: left">{{ optionItem.EntpCusName }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ optionItem.CallNum }}</span>
                    </el-option>
                    <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                </el-select>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="Visible = true">更多条件</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                <el-table-column min-idth="100px" prop="WarehouseName" label="出仓仓库" show-overflow-tooltip></el-table-column>
                <el-table-column width="160px" prop="OrderCode" label="销售单号" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div @dblclick="toNewPage(scope.row.EntpCusOId)">
                            {{ scope.row.OrderCode }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column min-width="80px" prop="APCode" label="配件编码" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <img src="@/assets/images/deled.png" title="已删" style="width: 20px; height: 20px" v-if="scope.row.GoodsState == 1" />
                        {{ scope.row.APCode }}
                    </template>
                </el-table-column>
                <el-table-column min-idth="100px" prop="GoodCode" label="互换码" show-overflow-tooltip></el-table-column>
                <el-table-column min-idth="100px" prop="GoodsName" label="配件名称" show-overflow-tooltip></el-table-column>
                <el-table-column min-idth="100px" prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                <el-table-column width="60" prop="Unit" label="单位" show-overflow-tooltip></el-table-column>
                <el-table-column width="80" prop="Count" label="销售数量"></el-table-column>
                <el-table-column width="80" prop="Price" label="销售价格"></el-table-column>
                <el-table-column width="100" prop="Cate" label="汽配分类" show-overflow-tooltip></el-table-column>
                <el-table-column width="200px" prop="EntpCusName" label="客户" show-overflow-tooltip></el-table-column>
                <el-table-column min-idth="100px" prop="Remark" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column width="80" prop="SName" label="业务员"></el-table-column>
                <el-table-column width="80px" label="订单状态">
                    <template slot-scope="scope">{{ scope.row.IsDelivery ? '已出仓' : '已提交' }}</template>
                </el-table-column>
                <el-table-column width="160px" prop="ConfirmTime" label="提交时间"></el-table-column>
                <el-table-column width="160px" prop="CreateTime" label="创建时间"></el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog 
            :close-on-click-modal="false" 
            title="更多查询条件" 
            :visible.sync="Visible" 
            id="search-order-dialog"   
            custom-class="search-item-dialog"
            :modal="false"
            append-to-body v-dialog-drag lock-scroll
            width="400px">
            <div class="dialog-content" v-if="Visible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="汽配编码">
                        <el-input
                            ref="search_1"
                            class="search-item"
                            size="small" 
                            v-model.trim="searchData.APCode" 
                            v-filter-special-char="searchData.APCode" 
                            placeholder="请输入汽配编码"
                            >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="汽配名称">
                        <el-select
                            ref="search_2"
                            size="small"
                            class="search-item"
                            v-model="searchData.GoodName"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入配件名称"
                            :remote-method="searchGoodName"
                            v-select-scroll-more="searchGoodNameLoad"
                            popper-class="my-select"
                            style="width: 100%;"
                        >
                            <el-option v-for="item in goodNameOptions" :key="item" :label="item" :value="item"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配车型">
                        <el-select
                            ref="search_3"
                            size="small"
                            class="search-item"
                            v-model="searchData.AutoSerise"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入车型"
                            :remote-method="searchAutoSerise"
                            v-select-scroll-more="searchAutoSeriseLoad"
                            popper-class="my-select"
                            style="width: 100%;"
                        >
                            <el-option v-for="item in autoSeriseOptions" :key="item" :label="item" :value="item" style="width: 300px"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            ref="search_4"
                            class="search-item"
                            v-model="searchData.Cate"
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            @visible-change="getGoodsType($event)"
                            style="width: 100%"
                            placeholder="请输入汽配分类"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value style="text-align:center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售单号">
                        <el-input
                            ref="search_5"
                            class="search-item"
                            size="small" 
                            v-model.trim="searchData.OrderCode" 
                            v-filter-special-char="searchData.OrderCode" 
                            placeholder="请输入销售单号"
                            >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="互换码">
                        <el-input
                            ref="search_6"
                            class="search-item"
                            size="small" 
                            v-model.trim="searchData.GoodCode" 
                            v-filter-special-char="searchData.GoodCode" 
                            placeholder="请输入互换码"
                            >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input
                            ref="search_7"
                            style="width: 100%"
                            size="small"
                            v-model.trim="searchData.Remark"
                            placeholder="请输入备注"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="客户">
                        <el-select
                            ref="search_8"
                            class="search-item"
                            v-model="cust"
                            filterable
                            clearable
                            allow-create
                            remote
                            reserve-keyword
                            value-key="EntpCusId"
                            size="small"
                            :remote-method="searchCustomer"
                            v-select-scroll-more="searchCustomLoad"
                            @visible-change="customerVisibleChange($event)"
                            @change="custChange($event)"
                            placeholder="输入客户名称/电话"
                            style="width: 100%"
                        >
                            <el-option v-for="optionItem in customerList" :key="optionItem.EntpCusId" :data-msg="optionItem" :label="optionItem.EntpCusName" :value="optionItem"
                                ><span style="float: left">{{ optionItem.EntpCusName }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ optionItem.CallNum }}</span>
                            </el-option>
                            <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="出仓仓库">
                        <el-select
                            ref="search_9"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.WarehouseId"
                            filterable
                            clearable
                            @visible-change="wHVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in warehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                                <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-date-picker
                            ref="search_10"
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="提交时间">
                        <el-date-picker
                            ref="search_11"
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog_N">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            loading: false,
            isUseSE: false,
            searchData: {
                APCode: '',
                GoodCode: '',
                AutoSerise: '',
                GoodName: '',
                Cate: '',
                Remark:'',
                OrderCode:'',
                EntpCusId: '',
                EntpCusName: '',
                WarehouseId:'',
                StartDate: '',
                EndDate: '',
                CStartDate: '',
                CEndDate: '',
                page: 1,
                limit: 15
            },
            typeList: [],
            tableData: [],
            customerList: [],
            tableDataLength: 0,
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            cateForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            cust: [], //客户对象，用于客户搜索
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            Visible:false,
            warehouseList:[],
            dateTimes1:[],
            dateTimes2:[],
            brandList:[],
            searchIndex:0,
        };
    },
    // activated() {
    //     debugger
    //     document.addEventListener('keydown', this.handleKeyEvent);
    // },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.Visible) this.Visible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        this.searchIndex = 0;

        let that = this;
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);

        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth() - 1, d.getDate()];
        let date2 = new Date(year2, month2, day2, 0);
        that.dateTimes2.push(date2);
        that.dateTimes2.push(date1);

        that.searchData.CStartDate = date2;
        that.searchData.CEndDate = date1;

        this.getConfigByCodes().then(() => {
            this.getTableData();
        });
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
             if (key === 13) {
                e.preventDefault();
                that.handleSearch();
            }             
            if (key === 27) {
                e.preventDefault();
                if (that.Visible) that.Visible = false;

            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!this.Visible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);

                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.Visible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //下键
            if (key == 40) {
                e.preventDefault();
                if (that.Visible) {
                    if (that.searchIndex != 11) {
                        if (that.searchIndex == 2 || that.searchIndex == 3 || that.searchIndex == 4 || that.searchIndex == 8 || that.searchIndex == 9) {
                            if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                        }
                        that.searchIndex += 1;
                        if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                    }
                }
            }
            //上键
            if (key == 38) {
                e.preventDefault();
                if (that.Visible) {
                    if (that.searchIndex != 0) {
                        if (that.searchIndex == 2 || that.searchIndex == 3 || that.searchIndex == 4 || that.searchIndex == 8 || that.searchIndex == 9) {
                            if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                        }
                        that.searchIndex -= 1;
                        if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                    }
                }
            }
        },
        resetSearch() {
            let that = this;
            that.searchData = {
                APCode: '',
                GoodCode: '',
                AutoSerise: '',
                GoodName: '',
                Cate: '',
                Remark:'',
                OrderCode:'',
                EntpCusId: '',
                EntpCusName: '',
                WarehouseId:'',
                StartDate: '',
                EndDate: '',
                CStartDate: '',
                CEndDate: '',
                page: 1,
                limit: that.commonPageSize
            };
            that.cust = '';
            that.dateTimes1 = [];
            that.dateTimes2 = [];
            that.autoSeriseOptions = [];
            let d = new Date();
            let year1, month1, day1;
            [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date1 = new Date(year1, month1, day1, 0);

            //前一天设定的日期时间 
            let year2, month2, day2;
            d.setTime(d.getTime());
            [year2, month2, day2] = [d.getFullYear(), d.getMonth() - 1, d.getDate()];
            let date2 = new Date(year2, month2, day2, 0);
            that.dateTimes2.unshift(date1);
            that.dateTimes2.unshift(date2);

            // that.searchData.StartDate = date2;
            // that.searchData.EndDate = date1;
            that.searchData.CStartDate = date2;
            that.searchData.CEndDate = date1;
        },
        getTableData() {
            let url = '';
            if (this.isUseSE) url = '/api/EntpSaleOrder/GetEntpSaleHisBySE';
            else url = '/api/EntpSaleOrder/GetSaleOrderHisList';
            
            this.$util
                .axiosGet({
                    url: url,
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    if (this.isUseSE) this.tableDataLength = res.count;
                });
            if (!this.isUseSE && this.searchData.page == 1) this.getDataCount();
        },
        getDataCount() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetSaleOrderHisCount',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.tableDataLength = res.count;
                });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['xslsssyq'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'xslsssyq': //使用搜索引擎配置
                                    this.isUseSE = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    this.$util.getWarehouse(1).then(data => {
                        this.warehouseList = data;
                    });
                }
            }
        },
        closeSearchDialog_N() {
            this.Visible = false;
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        toNewPage(id) {
            this.$router.push(`/salesManage/salesOrder/edit_v2?type=1&id=${id}`);
        },
        // 搜索汽配分类
        searchCate(key) {
            if (![undefined].includes(key)) {
                this.cateForm.Page = 1;
                this.cateForm.stopLoad = false;
                this.cateForm.key = key;
                this.typeList = [];
            }
            if (this.cateForm.stopLoad) return;
            this.loading = true;
            this.$util
                .getEntpApCategoryList(this.cateForm.key, this.cateForm.Page, this.cateForm.Limit)
                .then(data => {
                    this.loading = false;
                    if (!data) return;
                    this.cateForm.stopLoad = data.length < this.cateForm.Limit;
                    this.typeList = [...this.typeList, ...data];
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 客户名称列表，加载更多
        searchCateLoad() {
            this.cateForm.Page += 1;
            this.searchCate();
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        searchGoodsType() {
            if (this.typeList.length > 0) return;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                })
                .catch(() => {});
        },
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        custChange(val) {
            let that = this;
            if (!val) {
                that.searchData.EntpCusId = '';
                that.searchData.EntpCusName = '';
                that.cusForm.key = '';
            } else if (typeof val == 'string') {
                that.searchData.EntpCusId = '';
                that.searchData.EntpCusName = val;
            } else {
                that.searchData.EntpCusId = val.EntpCusId;
                that.searchData.EntpCusName = '';
            }
        },
        // 搜索顾客
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.customerList = [];
            }
            if (this.cusForm.stopLoad) return;
            this.loading = true;
            this.$util
                .searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit)
                .then(data => {
                    this.loading = false;
                    if (!data) return;
                    this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                    this.customerList = [...this.customerList, ...data];
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) that.searchGoodsBrand();
            }
        },
        searchGoodsBrand() {
            this.selLoading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustomer();
        },
        async searchGoodName(key) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                this.goodNameOptions = [...this.goodNameOptions, ...data];
            }
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        async searchAutoSerise(key) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...data];
            }
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
    }
};
</script>
<style lang="less" scoped>
#search-order-dialog {
    position: absolute;
    top: 0;
    left: 40%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
            margin-right: 10px;
        }
        .el-form-item {
            margin-bottom: 0;
            margin-right: 10px;
            margin-left: 10px;

        }
    }
    .el-dialog__body {
        height: 485px;
        overflow: auto;
    }
    .el-range-editor--small .el-range-separator{
        width: 24px !important;
    }
}    
</style>